// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4277) return "static/chunks/4277-5c9082650adcaa03.js";
	if (chunkId === 3568) return "static/chunks/3568-a016e768dcb7c506.js";
	if (chunkId === 2120) return "static/chunks/2120-de3b462937b5c087.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3671":"28efe86118420e97","4047":"6a3a2670076df01e","8491":"82067ee2fe034dfd","9321":"c97b08db470a61dd"}[chunkId] + ".js";
};